import React from "react";

const CTA = () => {
  return (
    <div className="cta">
      <div className="cta__content">
        <p>Request Early Access to Get Started</p>
        <h3>Register Today & start exploring the endless possibilities.</h3>
      </div>
      <div className="cta__button">
        <button type="button">Get Started</button>
      </div>
    </div>
  );
};

export default CTA;
